if (!customElements.get('build-your-bundle')) {
  customElements.define('build-your-bundle', class BuildYourBundle extends HTMLElement {
    constructor() {
      super();
      this.getSteps();
    }

    init() {
      this.productCardCheckbox = this.querySelectorAll('.byob-product-card__input');
      this.progressBarIndex = this.querySelector('.byob-main__progress-bar-index');
      this.regularProductCardCheckbox = this.querySelectorAll('.byob-product-card__checkbox[regular-product]');
      this.progressBarItems = this.querySelectorAll('.byob-main__progress-bar-item');
      this.progressBarItemsLength = this.progressBarItems.length;
      this.progressBarAdditionalItem = this.querySelector('.byob-main__progress-bar-item.byob-main__progress-bar-item--additional');
      this.disabledCheckboxes = this.querySelectorAll('.byob-product-card__checkbox[disabled]');
      this.sampleProductSection = this.querySelector('.byob-main[data-sample-product="true"]');
      this.regularProductSection = this.querySelectorAll('.byob-main[data-regular-product="true"]');
      this.regularProductSectionLength = this.regularProductSection.length;
      this.form = this.querySelector('form');
      //this.addButton = this.form.querySelectorAll('.byob-add-btn');
      this.wantMoreButton = this.querySelector('.byob-main__progress-bar-scroll-top');
      this.firstProductSection = this.querySelector('.byob-main-1 .byob-main__products-heading');
      this.desktopAddToCartButton = this.querySelector('.byob-add-btn--desktop');
      this.mobileAddToCartButton = this.querySelector('.byob-add-btn--mobile');
      this.scrollTopButton = this.querySelector('.byob__scroll-top');
      this.targetSectionTop = document.querySelector('.byob-main-2').getBoundingClientRect().top;
      this.informationPopup = this.querySelector('.byob-main__information-popup');
      this.closeInformationPopupButton = this.querySelector('.byob-main__close-popup');
      this.tagetSection = this.targetSectionTop + window.scrollY;

      this.closeInformationPopupButton.addEventListener('click', () => {
        this.informationPopup.classList.remove('show-information-popup');
      })

      this.wantMoreButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollTop();
      })

      this.scrollTopButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollTop();
      })

      window.addEventListener('scroll', this.checkScrollPosition.bind(this));
      window.addEventListener('load', this.checkScrollPosition.bind(this));

      this.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.addProduct(e);
        } else {
          let cnt = 0;
          this.deleteProduct();
          this.productCardCheckbox.forEach(input => {
            if (input.checked) {
              this.renderProgressBar(false, input, cnt);
              cnt = cnt + 1;
            }
          })
        }
      })

      this.addEventListener('deleteSample', (e) => {
        this.deleteSample();
      })
    }

    scrollTop() {
      if (window.innerWidth <= 1024) {
        const headerHeight = document.querySelector('.header .sidebar-nav').offsetHeight;
        const targetPosition = this.firstProductSection.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: targetPosition - headerHeight - 25,
          behavior: 'smooth'
        });
      } else {
        this.firstProductSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }

    checkScrollPosition() {
      const selectRegularProductLength = this.querySelectorAll('.byob-main__progress-bar-item[data-regular-product="true"]').length;
      if (window.scrollY > this.tagetSection  && selectRegularProductLength === 0) {
        this.scrollTopButton.classList.add('show-top-button');
      } else {
        if (this.scrollTopButton.classList.contains('show-top-button')) {
          this.scrollTopButton.classList.remove('show-top-button');
        }
      }
    }

    getSteps() {
      const scriptObj = this.querySelector('.byob-product-script');
      const steps = JSON.parse(scriptObj.textContent);
      steps.forEach((step, i) => {
        this.getAllProducts(step['urlArr'], i).then(()=> this.init())
      });
    }

    getAllProducts(urlArr, i) {
      this.productWrappers = this.querySelectorAll('.byob-main__products-wrapper');
      return Promise.all(urlArr.map(url => {
        return fetch(url).then(resp => resp.text())
      })).then(respText => {
        const html = new DOMParser().parseFromString(respText, 'text/html');
        const cards = html.querySelectorAll('.byob-product-card');

        if (!cards) return false;

        const productCards = Array.from(cards).filter(card => {
          //const sectionIndex = i + 1;
          //card.querySelector('.byob-product-card__label--checked span').innerHTML = sectionIndex;
          return card.hasAttribute('product-available');
        });

        this.productWrappers[i].innerHTML = '';
        this.productWrappers[i].append(...productCards);
      })
    }

    isCheckedSampleProduct() {
      const sampleInputs = this.sampleProductSection.querySelectorAll('input[type="checkbox"]');
      let isChecked = false;
      sampleInputs.forEach((input) => {
        if (input.checked) {
          isChecked = true;
        }
      })
      return isChecked;
    }

    addProduct(e) {
      const newIndex = Array.from(this.productCardCheckbox).filter((input) => input.checked).length - 1;
      this.renderProgressBar(e, null, newIndex);
    }

    deleteProduct() {
      const selectRegularProductLength = this.querySelectorAll('.byob-main__progress-bar-item[data-regular-product="true"]').length;
      const lastElement = this.progressBarItems.length - 1;
      if (this.regularProductSectionLength < selectRegularProductLength) {
        const item = this.progressBarItems[lastElement];
        const label = item.querySelector('button[type="button"] label');
        const labelValue = label.getAttribute('for');
        const image = item.querySelector('img');
        const imgAttr = {
          "src": '',
          "alt": ''
        }

        const input = document.querySelector(`input[id=${labelValue}]`);
        input.checked = false;

        label.setAttribute('for', '');
        this.setAttributes(image, imgAttr)
        item.classList.remove('byob-main__progress-bar-item-with-product');
        item.removeAttribute('data-regular-product');
        item.removeAttribute('data-sample-product');
      }

      this.progressBarItems.forEach((item, index) => {
          const label = item.querySelector('button[type="button"] label');
          const image = item.querySelector('img');
          const imgAttr = {
            "src": '',
            "alt": ''
          }

          label.setAttribute('for', '');
          this.setAttributes(image, imgAttr)
          item.classList.remove('byob-main__progress-bar-item-with-product');
          item.removeAttribute('data-regular-product');
          item.removeAttribute('data-sample-product');
      })

      // if (selectRegularProductLength === 1) {
      //   this.addButton.forEach((button) => {
      //     button.setAttribute('disabled', '');
      //   })
      // }
    }

    setAttributes(el, attrObj) {
      Object.keys(attrObj)?.forEach(key => el?.setAttribute(key, attrObj[key]));
    }

    renderProgressBar(e, target, index) {
      const input = e ? e.target : target;
      const productScriptElement = input.closest('.byob-product-card').querySelector('script');
      const cardObject = JSON.parse(productScriptElement.textContent);
      this.renderProgressBarItem(index, cardObject);
    }

    renderProgressBarItem(index, cardObject) {
      const {id, src, alt, is_regular_product, is_sample_product, label_for} = cardObject;
      const item = this.progressBarItems[index]
      const image = item?.querySelector('img');
      const label = item?.querySelector('button[type="button"] label');
      item?.classList.add('byob-main__progress-bar-item-with-product');

      const attributes = {
        "src": src,
        "alt": alt
      }

      const labelAttributes = {
        "for": label_for
      }

      this.setAttributes(image, attributes);
      this.setAttributes(label, labelAttributes);
      item?.setAttribute('data-regular-product', is_regular_product);
      item?.setAttribute('data-sample-product', is_sample_product);

      const selectRegularProductCount = this.querySelectorAll('.byob-main__progress-bar-item[data-regular-product="true"]').length;
      this.makeSampleAvailableToSelect(selectRegularProductCount);

      // if (selectRegularProductCount > 0) {
      //   this.addButton.forEach((button) => {
      //     button.removeAttribute('disabled');
      //   })
      // }

      if (this.isCheckedSampleProduct() && this.regularProductSectionLength > selectRegularProductCount) {
        this.deleteSample();
      }

      if (this.isCheckedSampleProduct() && this.regularProductSectionLength <= selectRegularProductCount) {
        if (window.innerWidth <= 1024) {
          this.mobileAddToCartButton.style.display = 'block';
        }

        if (window.innerWidth > 1024) {
          this.desktopAddToCartButton.style.display = 'block';
        }
      } else {
        if (window.innerWidth <= 1024) {
          this.mobileAddToCartButton.style.display = 'none';
        }

        if (window.innerWidth > 1024) {
          this.desktopAddToCartButton.style.display = 'none';
        }
      }

      if (this.isCheckedSampleProduct() && this.regularProductSectionLength === selectRegularProductCount) {
        this.progressBarAdditionalItem.classList.add('show-text');
        this.progressBarIndex.style.opacity = '1';
      } else if (this.progressBarAdditionalItem.classList.contains('show-text')) {
        this.progressBarAdditionalItem.classList.remove('show-text');
        this.progressBarIndex.style.opacity = '0';
      }

      this.disabledRegularProductInputs(selectRegularProductCount);
    }

    disabledRegularProductInputs(selectRegularProductCount) {
      this.regularProductCardCheckbox.forEach((input) => {
        if (this.regularProductSectionLength === selectRegularProductCount && !this.isCheckedSampleProduct()) {
          input.setAttribute('disabled', '');
          this.informationPopup.classList.add('show-information-popup');
          this.closeInformationPopupButton.focus();
        } else if (this.regularProductSectionLength > selectRegularProductCount) {
          input.removeAttribute('disabled');
          this.informationPopup.classList.remove('show-information-popup');
        } else if (this.regularProductSectionLength === selectRegularProductCount && this.isCheckedSampleProduct()) {
          input.removeAttribute('disabled');
          this.informationPopup.classList.remove('show-information-popup');
        } else if (this.regularProductSectionLength < selectRegularProductCount && this.isCheckedSampleProduct()) {
          input.setAttribute('disabled', '');
        }
      })
    }

    deleteSample() {
      this.progressBarItems.forEach((item, index) => {
        if (item.getAttribute('data-sample-product') == 'true') {
          const label = item.querySelector('button[type="button"] label');
          const labelValue = label.getAttribute('for');
          const image = item.querySelector('img');
          const imgAttr = {
            "src": '',
            "alt": ''
          }

          const input = document.querySelector(`input[id=${labelValue}]`);
          input.checked = false;
          label.setAttribute('for', '');
          this.setAttributes(image, imgAttr)
          item.classList.remove('byob-main__progress-bar-item-with-product');
          item.removeAttribute('data-regular-product');
          item.removeAttribute('data-sample-product');
        }
      })
    }

    makeSampleAvailableToSelect(selectRegularProductCount) {
      this.disabledCheckboxes.forEach((label) => {
        if (this.regularProductSectionLength === selectRegularProductCount && !this.isCheckedSampleProduct()) {
          label.removeAttribute('disabled');
        } else {
          label.setAttribute('disabled', '');
        }
      })
    }
  });
}
